import { ClmmPoolUtil, type Pool, TickMath } from '@cetusprotocol/cetus-sui-clmm-sdk';
import { useAddress } from '@hooks/use-address';
import { type CoinStruct } from '@models/coins.vault.model';
import { type MyVaultsStruct } from '@models/myvault.model';
import { numericFormat } from '@utils/index';
import { scaleDown } from '@utils/math';
import { BN, Decimal } from 'parrot-sui-sdk';
import { FC } from 'react';
import { OpenapiClientParrotVault } from 'src/openapi/parrot-vault';
import styles from './index.module.scss';

interface OwnProps {
  pool: Pool | undefined;
  vault: OpenapiClientParrotVault.GetVaultVaultsResponse['result'][number];
  coinA: CoinStruct;
  coinB: CoinStruct;
  myVault: MyVaultsStruct | undefined;
}

const YourDeposited: FC<OwnProps> = ({ myVault, vault, pool, coinA, coinB }) => {
  const address = useAddress();
  if (!address) return null;

  // let deposit_usd = new Decimal(0);

  // if (pool && myVault) {
  //   const coinAmounts = ClmmPoolUtil.getCoinAmountFromLiquidity(
  //     new BN(myVault.liquidity),
  //     new BN(pool.current_sqrt_price),
  //     TickMath.tickIndexToSqrtPriceX64(vault.tick_lower),
  //     TickMath.tickIndexToSqrtPriceX64(vault.tick_upper),
  //     false,
  //   );

  //   deposit_usd = deposit_usd
  //     .add(scaleDown(coinAmounts.coinA.toString(), coinA.decimals).mul(coinA.price_usd))
  //     .add(scaleDown(coinAmounts.coinB.toString(), coinB.decimals).mul(coinB.price_usd));
  // }

  return (
    <div className={styles.your}>
      Your Deposited: <span>${numericFormat(vault.balance)}</span>
    </div>
  );
};

export default YourDeposited;
